import { Link } from "@offstreetparking/design-system/typography";
import { usePathname } from "next/navigation";
import type { HTMLAttributeAnchorTarget, PropsWithChildren } from "react";

type TopBarNavLinkProps = {
	href: string;
	isVisible?: boolean;
	isActive?: boolean;
	target?: HTMLAttributeAnchorTarget;
	"aria-label"?: string;
};

export const TopBarNavLink = ({
	href,
	isVisible = true,
	isActive,
	target,
	"aria-label": ariaLabel,
	children,
}: PropsWithChildren<TopBarNavLinkProps>) => {
	const pathname = usePathname();

	if (!isVisible) {
		return null;
	}

	const active = isActive ?? pathname === href;

	return (
		<Link variant={active ? "nav" : "tertiary"} size="sm" href={href} target={target} aria-label={ariaLabel}>
			{children}
		</Link>
	);
};
